import { render, staticRenderFns } from "./TransactionItem.vue?vue&type=template&id=596b548a&scoped=true"
import script from "./TransactionItem.vue?vue&type=script&lang=ts"
export * from "./TransactionItem.vue?vue&type=script&lang=ts"
import style0 from "./TransactionItem.vue?vue&type=style&index=0&id=596b548a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b548a",
  null
  
)

export default component.exports